import { reducer as reschedules } from "./queue/slice";

export const reducer = {
  reschedules,
};
